import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-re-addmission',
  templateUrl: './re-addmission.component.html',
  styleUrls: ['./re-addmission.component.scss']
})
export class ReAddmissionComponent implements OnInit {
  reAddmission : FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;

  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    this.reAddmission = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Valid: new FormControl(),
      Change: new FormControl(),
      Colg: new FormControl(),
      RgNo: new FormControl(),
      ReAdmit : new FormControl(),
      Valid2: new FormControl(),
      Valid3: new FormControl(),
    });
    this.fetchList();
  }


  fetchList(){
    let payload = {}
    payload ["SnNo"] = this.umsService.secretdata['SnNo'];
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
    if (res.status) {
      this.ListOfMarks = res.data;
      this.filteredListOfMarks = this.ListOfMarks.slice();
    }
    else {
    
    }
    
    });
    
      }
}
